<template>
    <a-card ref="FreeEvaluationDetail">
        <a-form-model class="search-form" layout="inline" :model="searchForm">
            <a-form-model-item label="手机号">
                <a-input :maxLength="11" allowClear v-model="searchForm.mobile" placeholder="请输入手机号"/>
            </a-form-model-item>
            <a-form-model-item label="测评名称">
                <a-select v-model="searchForm.courseId" allowClear placeholder="请选择测评名称">
                    <a-select-option :value="item.courseId" :key="item.courseId" v-for="item in groupCourseList">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="测评完成时间">
                <a-range-picker @change="pickerChange" v-model="time" :align="{points: ['tr']}" allowClear/>
            </a-form-model-item>
            <a-form-model-item label="渠道来源">
                <a-select v-model="searchForm.channel" allowClear placeholder="请选择渠道来源">
                    <a-select-option :value="item.id" :key="item.id" v-for="item in channelList">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div style="overflow: auto;">
            <a-table style="min-width: 800px;"
                     :columns="columns"
                     :rowKey="(text, index) => text.userId + '' + index"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :dataSource="tableRelevant.tableDataSource">
            </a-table>
        </div>
    </a-card>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import $Bus from "@/pages/projectImpl/js/eventBus";

    const columns = [
        {
            title: '手机号',
            dataIndex: 'mobile'
        },
        {
            title: '渠道来源',
            dataIndex: 'channelName'
        },
        {
            title: '测评名称',
            dataIndex: 'evaluationCourseName'
        },
        {
            title: '测评完成时间',
            dataIndex: "completionTime"
        },
        {
            title: '领取课程',
            dataIndex: 'courseName'
        },
        {
            title: '测评成绩',
            dataIndex: 'score'
        }
    ];
    export default {
        name: "FreeEvaluationDetail",
        data() {
            return {
                columns,
                time: undefined,
                searchForm: {
                    mobile: undefined,
                    startTime: undefined,
                    endTime: undefined,
                    courseId: undefined,
                    channel: undefined,
                },
                channelList: [],
                groupCourseList: [],
                //表格相关
                tableRelevant: tableRelevant.call(this),
            }
        },
        mounted() {
            $Bus.$emit("pageHeaderTitle", this.$route.query.name);
            const breadcrumb = [
                "首页",
                "运营中心",
                {name: "免费测评", path: "/operate/FreeEvaluation"},
                "项目详情"
            ];
            $Bus.$emit("pageHeaderBreadcrumb", breadcrumb);

            this.getPageList(1);
            this.getChannelList();
            this.getGroupCourseList();
        },
        methods: {
            getPageList(pageIndex) {
                const params = {
                    groupId: this.$route.query.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.Channel.getFreeGroupPageList(params).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const {data} = res.data;
                    this.tableRelevant.tableDataSource = data.items.map(m => ({
                        ...m,
                        score: m.score || "--",
                        courseName: m.courseName || "--",
                        completionTime: m.completionTime === "0001-01-01 00:00:00" ? "--" : m.completionTime
                    }));
                    this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
                })
            },

            getChannelList() {
                const params = {
                    pageIndex: 1,
                    pageSize: 9999,
                };
                this.$http.Channel.getChannelPageList(params).then(res => {
                    const {data} = res.data;
                    this.channelList = data.items;
                })
            },

            getGroupCourseList() {
                const params = {
                    groupId: this.$route.query.id,
                    pageIndex: 1,
                    pageSize: 9999,
                };
                this.$http.operate.GetGroupCoursePageList(params).then(res => {
                    const {data} = res;
                    this.groupCourseList = data.items;
                })
            },

            //重置
            searchReset() {
                for (let key in this.searchForm) {
                    this.searchForm[key] = undefined;
                }
                this.time = undefined;
                this.getPageList(1);
            },

            pickerChange(val) {
                if (Array.isArray(val) && val.length) {
                    this.searchForm.startTime = val[0].format('YYYY-MM-DD');
                    this.searchForm.endTime = val[1].format('YYYY-MM-DD');
                } else {
                    this.searchForm.startTime = undefined;
                    this.searchForm.endTime = undefined;
                }
            }
        }
    }
</script>

<style scoped>

</style>
